import { useRouteMatcher } from '@folklore/routes';
import { useMemo } from 'react';
import { useLocation } from 'wouter';

export default function useRoutesMatch(routes, specificLocation) {
    const routeMatcher = useRouteMatcher();
    const [location] = useLocation();
    return useMemo(
        () =>
            routes.reduce((isMatching, route) => {
                if (isMatching) {
                    return true;
                }
                const [match = false] = routeMatcher(route, specificLocation || location);
                return match;
            }, false),
        [...routes, routeMatcher, specificLocation, location],
    );
}
